import { Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { getRouterPathToContentIndex } from '../../utilities/Links';
import { v4 as uuidv4 } from 'uuid';

interface CategoryListProps {
  readonly categories?: string[];
  readonly variant?: 'mobile' | 'default';
  readonly onClick?: () => void;
}

export default function CategoryList({
  categories,
  variant = 'default',
  onClick = () => {},
}: CategoryListProps) {
  return (
    <Stack
      direction='row'
      component={Typography}
      variant='caption'
      sx={{ color: 'text.secondary', flexWrap: 'wrap' }}
    >
      {categories?.map((category, i) => {
        const uuid = uuidv4();

        return [
          i > 0 && (
            <Typography
              key={'author-list-comma-' + uuid}
              variant='caption'
              sx={{
                paddingY: variant === 'mobile' ? 1.5 : 0,
                marginRight: i > 0 ? 0.5 : 0,
              }}
            >
              ,
            </Typography>
          ),
          <Link
            key={'category-' + category}
            component={RouterLink}
            to={getRouterPathToContentIndex(category)}
            onClick={() => onClick()}
            underline='hover'
            variant='caption'
            sx={{
              paddingBottom: 0,
              paddingY: variant === 'mobile' ? 1.5 : 0,
              color: 'text.secondary',
              display: 'block',
              flexWrap: 'nowrap',
            }}
          >
            {category}
          </Link>,
        ];
      })}
    </Stack>
  );
}
